import { Injectable } from '@angular/core';
import { Stream } from 'src/models/stream';
import { Observable, Subject, BehaviorSubject } from 'rxjs';
import { StreamService } from './stream.service';
import { Episode } from 'src/models/episode';

@Injectable({
  providedIn: 'root'
})
export class PlayerService {

  public currentStream: Subject<Stream>;

  public isPlaying: BehaviorSubject<boolean>;

  public invokePause: Subject<boolean>;

  constructor(private streamService: StreamService) {
    this.currentStream = new Subject<Stream>();
    this.isPlaying = new BehaviorSubject<boolean>(false);
    this.invokePause = new Subject<boolean>();
  }

  public setCurrentStream(stream: Stream) {
    this.currentStream.next(stream);
  }

  public getStreamUrls(stream: Stream): Observable<string[]> {
    return this.streamService.parsePlaylist(stream);
  }

  public setPlaying(playing: boolean) {
    this.isPlaying.next(playing);
  }

  public pause() {
    this.invokePause.next(true);
  }
}
